import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";

import { catchError, switchMap, take, throwError } from "rxjs";

import { AuthService } from "@auth0/auth0-angular";

import { SKIP_AUTH0 } from "../tokens/http-context.tokens";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_AUTH0)) {
    return next(req);
  }

  const auth0: AuthService = inject(AuthService);

  return auth0.idTokenClaims$.pipe(
    take(1),
    switchMap(token => {
      const requestWithToken = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token?.__raw}`,
        },
      });

      return next(requestWithToken);
    }),
    catchError(error => {
      console.error("Falha de autenticação:", error);

      auth0.logout({
        logoutParams: { returnTo: globalThis.location.origin },
      });

      return throwError(() => error);
    })
  );
};
